import { AppStore } from "store";
import { makeAutoObservable, runInAction } from "mobx";

export default class LicensesStore {
  private rootStore: AppStore;

  constructor(rootStore: AppStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  public getLicenses(): void {
    runInAction(() => {
      this.getLicenses = null;
    });
  }
}
